import { useQuery } from "@tanstack/react-query";
import { Integration, Order as OrderType } from "/app/src/models";
import { orderService } from "/app/src/services";
import { useParams } from "react-router-dom";
import ManualOrderDetails from "./manualOrderDetails";

/**
 * Renders order details and lines for the specified order.
 * Fetches the order using orderId from route parameters.
 *
 * @returns {JSX.Element} The rendered order details and lines components.
 */
/**
 * Component for processing an order.
 * @returns {JSX.Element}
 */
export default function ManualOrderProcessorOrder({
  integration,
}: {
  integration: Integration;
}) {
  const { orderId } = useParams();

  const { data: order } = useQuery({
    queryKey: ["order", orderId],
    queryFn: () => {
      return orderService.getSingle(orderId);
    },
    initialData: { order: {} },
    select: (data: { order: OrderType }) => {
      return data.order;
    },
  });

  return <ManualOrderDetails integration={integration} order={order} />;
}
